<template>
  <div
    class="custom-datetime-picker"
    @mousedown="onMouseDown"
    @mouseup="onMouseUp"
    @mousemove="onMouseMove"
    @mouseleave="onMouseUp"
  >
    <div v-if="mode === 'daterange'" class="mb-[10px]">
      <el-radio-group v-model="daterange_type_component" size="mini">
        <el-radio-button label="group">Gộp ngày</el-radio-button>
        <el-radio-button label="split">Chia nhỏ</el-radio-button>
      </el-radio-group>
    </div>

    <div class="vi-schedule-calendar">
      <div class="table-wrap">
        <table class="vi-schedule-calendar-table">
          <thead>
          <tr class="vi-schedule-calendar-time-all">
            <th rowspan="8" class="vi-schedule-calendar-week-td">Tuần/Giờ</th>
            <th colspan="24" class="vi-schedule-calendar-time">00:00 - 12:00</th>
            <th colspan="24" class="vi-schedule-calendar-time">12:00 - 24:00</th>
          </tr>
          <tr class="vi-schedule-calendar-time-item">
            <td v-for="hour in 24" colspan="2">{{ hour - 1 }}</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(day, rowIndex) in days" :key="rowIndex">
            <td v-html="day.label"></td>
            <td
              v-for="(slot, colIndex) in day.slots"
              :key="colIndex"
              :class="['calendar-cell', { selected: slot.selected, hovering: isDragging && isCellInRange(rowIndex, colIndex) }]"
              :data-row="rowIndex"
              :data-col="colIndex"
              @mouseenter="onMouseEnter($event)"
            ></td>
          </tr>

          <tr elementtiming="shopping-creation-element-timing">
            <td colspan="49" class="vi-schedule-result" elementtiming="shopping-creation-element-timing">
              <div class="clearfix" elementtiming="shopping-creation-element-timing">
                <span v-if="hasAnySelection()" elementtiming="shopping-creation-element-timing">
                  Khoảng thời gian được chọn
                </span>
                <span v-else elementtiming="shopping-creation-element-timing">
                  Kéo chuột để chọn koảng thời gian
                </span>
                <button v-if="hasAnySelection()"
                        data-testid="schedule-schedule-6XQn9m" type="button"
                        class="vi-button vi-byted-button clear-all vi-button--text vi-button--small"
                        elementtiming="shopping-creation-element-timing" @click="clearSelection()">
                  <span elementtiming="shopping-creation-element-timing">Xóa tất cả</span>
                </button>
              </div>

              <div elementtiming="shopping-creation-element-timing">
                <div elementtiming="shopping-creation-element-timing">
                  <div v-for="item in getSelectedTimeRanges()" elementtiming="shopping-creation-element-timing"
                       class="flex gap-[20px] items-center">
                    <span class="vi-schedule-result-title" elementtiming="shopping-creation-element-timing">
                      {{ item.label }}
                    </span>
                    <span class="vi-schedule-result-value" elementtiming="shopping-creation-element-timing">
                      {{ item.times.join('、') }}
                    </span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from '../../../addon/dayjs'

export default {
  props: {
    mode: {
      type: String,
      default: () => 'week'
      // default: () => 'daterange'
    },
    daterange: {
      type: Array,
      default: () => []
      // default: () => [dayjs([2025, 1, 1]).toDate(), dayjs([2025, 1, 20]).toDate()]
    },
    daterange_type: {
      type: String,
      default: () => 'group' // todo: need to sync
    },
    value: {
      type: Array,
      default: () => [] // todo: need to sync
    }
  },

  data() {
    return {
      days: [],
      dragStart: null,
      dragEnd: null,
      isDragging: false,
      dragValue: null,
      daterange_type_component: 'group'
    }
  },

  beforeMount() {
    this.daterange_type_component = this.daterange_type
    this.generateDays()
  },

  watch: {
    mode: {
      immediate: false,
      handler(new_value) {
        if (new_value) this.generateDays()
      }
    },

    daterange: {
      immediate: false,
      handler(new_value) {
        if (new_value) this.generateDays()
      }
    },

    daterange_type_component: {
      handler(new_value) {
        if (new_value) {
          this.generateDays()
          this.$emit('update:daterange_type', new_value)
        }
      }
    },

    value: {
      immediate: true,
      handler(new_value) {
        this.generateDays();
      }
    }
  },

  methods: {
    generateDays() {
      this.days = []

      if (!this.mode || this.mode === 'week') {
        const days_in_week = ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN']
        this.days = days_in_week.map(i => ({
          label: i,
          slots: Array(48).fill({}).map(() => ({selected: false}))
        }))
      }

      if (this.mode === 'daterange') {
        if (this.daterange && this.daterange.length) {
          let start_time = this.dayjs(this.daterange[0])
          const end_time = this.dayjs(this.daterange[1])

          if (!this.daterange_type_component || this.daterange_type_component === 'group') {
            this.days = [
              {
                label: `${start_time.format('DD/MM/YYYY')} <br> - <br> ${end_time.format('DD/MM/YYYY')}`,
                slots: Array(48).fill({}).map(() => ({selected: false}))
              }
            ]
          }

          if (this.daterange_type_component === 'split') {
            while (start_time.isSameOrBefore(end_time, 'day')) {
              this.days.push({
                label: `${start_time.format('DD/MM/YYYY')}`,
                slots: Array(48).fill({}).map(() => ({selected: false}))
              })
              start_time = start_time.add(1, 'day')
            }
          }
        }
      }

      // todo: reset selected values
      this.clearSelection()
      this.value.forEach(({
                            day,
                            slot
                          }) => {
        if (this.days[day] && this.days[day].slots[slot]) {
          this.$set(this.days[day].slots[slot], 'selected', true)
        }
      })
    },

    hasAnySelection() {
      return this.days.some(day => day.slots.some(slot => slot.selected));
    },

    isCellInRange(row, col) {
      if (!this.dragStart || !this.dragEnd) return false;
      const startRow = Math.min(this.dragStart.row, this.dragEnd.row);
      const endRow = Math.max(this.dragStart.row, this.dragEnd.row);
      const startCol = Math.min(this.dragStart.col, this.dragEnd.col);
      const endCol = Math.max(this.dragStart.col, this.dragEnd.col);
      return row >= startRow && row <= endRow && col >= startCol && col <= endCol;
    },

    getSelectedTimeRanges() {
      const result = [];

      this.days.forEach((day) => {
        const ranges = [];
        let rangeStart = null;

        day.slots.forEach((slot, slotIndex) => {
          const isSelected = slot.selected;
          const isNextSelected = (day.slots[slotIndex + 1] && day.slots[slotIndex + 1].selected) ? true : false;

          if (isSelected && rangeStart === null) {
            rangeStart = slotIndex;
          }

          if (rangeStart !== null && (!isNextSelected || slotIndex === 47)) {
            const startTime = this.slotIndexToTime(rangeStart);
            const endTime = this.slotIndexToTime(slotIndex + 1);
            ranges.push(`${startTime}~${endTime}`);
            rangeStart = null;
          }
        });

        if (ranges.length) {
          result.push({
            label: day.label.replaceAll('<br>', ''),
            times: ranges
          });
        }
      });

      return result;
    },

    slotIndexToTime(index) {
      const hour = Math.floor(index / 2);
      const minute = (index % 2) * 30;
      return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
    },

    clearSelection() {
      this.days.forEach(day => {
        day.slots.forEach(slot => {
          slot.selected = false;
        });
      });
    },

    emitSelected() {
      const result = [];
      this.days.forEach((day, rowIndex) => {
        day.slots.forEach((slot, colIndex) => {
          if (slot.selected) {
            result.push({
              day: rowIndex,
              slot: colIndex
            });
          }
        });
      });

      this.$emit('update:value', result);
    },

    onMouseDown(e) {
      const cell = this.getCellFromEvent(e);
      if (!cell) return;
      this.isDragging = true;
      this.dragStart = cell;
      const current = this.days[cell.row].slots[cell.col];
      this.dragValue = !current.selected;
      this.updateDragRange(cell);
    },

    onMouseEnter(e) {
      if (!this.isDragging) return;
      const cell = this.getCellFromEvent(e);
      if (!cell) return;
      this.dragEnd = cell;
      this.updateDragRange(this.dragEnd);
    },

    onMouseMove(e) {
      if (!this.isDragging) return;
      const cell = this.getCellFromEvent(e);
      if (cell) {
        this.dragEnd = cell;
        this.updateDragRange(cell);
      }
    },

    onMouseUp() {
      this.isDragging = false;
      this.dragStart = null;
      this.dragEnd = null;
      this.dragValue = null;
      this.days.forEach(day => day.slots.forEach(slot => slot.hover = false));
      this.emitSelected();
    },

    getCellFromEvent(e) {
      const target = e.target.closest('.calendar-cell');
      if (!target || !target.dataset) return null;
      const row = Number(target.dataset.row);
      const col = Number(target.dataset.col);
      if (isNaN(row) || isNaN(col)) return null;
      return {
        row,
        col
      };
    },

    updateDragRange(current) {
      const startRow = Math.min(this.dragStart.row, current.row);
      const endRow = Math.max(this.dragStart.row, current.row);
      const startCol = Math.min(this.dragStart.col, current.col);
      const endCol = Math.max(this.dragStart.col, current.col);

      this.dragStart = this.dragStart || current;
      this.dragEnd = current;

      for (let row = 0; row < this.days.length; row++) {
        for (let col = 0; col < 48; col++) {
          const inRange = row >= startRow && row <= endRow && col >= startCol && col <= endCol;
          if (inRange) {
            this.$set(this.days[row].slots[col], 'hover', true);
          } else {
            this.$set(this.days[row].slots[col], 'hover', false);
          }
          if (inRange && this.dragValue !== this.days[row].slots[col].selected) {
            this.$set(this.days[row].slots[col], 'selected', this.dragValue);
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-datetime-picker {
  width: 100%;

  .clear-all {
    span {
      color: #2b97f0;
      font-weight: 600;
      font-size: 12px;
    }
  }

  .dragging .calendar-cell.hovering {
    background-color: rgba(66, 185, 131, 0.3);
    transition: background-color 0.2s ease;
  }

  .calendar-cell {
    width: 10px;
    height: 20px;
    border: 1px solid #ccc;
    cursor: pointer;
    user-select: none;
  }

  .selected {
    background-color: #80bfff;
    transition: background .2s ease;
  }

  /*! CSS Used from: Embedded */
  :not(.TTAMMAIN-origin-scrollbar)::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
  }

  :not(.TTAMMAIN-origin-scrollbar)::-webkit-scrollbar-button {
    display: none;
  }

  :not(.TTAMMAIN-origin-scrollbar)::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(51, 51, 51, .16);
  }

  :not(.TTAMMAIN-origin-scrollbar)::-webkit-scrollbar-thumb:hover {
    background-color: rgba(51, 51, 51, .5);
  }

  /*! CSS Used from: Embedded */
  button {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: TikTok Text, TikTok Display, -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
  }

  /*! CSS Used from: https://lf16-ttmp.tiktokstaticb.com/obj/ttastatic-sg/tt4b_main/css/chunk-vendors.bc60134c.css */
  * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .vi-button {
    height: 34px;
    font-size: 14px;
  }

  [dir] .vi-button {
    padding: 8px 16px;
  }

  .vi-button {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    color: #121415;
    -webkit-appearance: none;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    transition: .1s;
    font-weight: 400;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }

  [dir] .vi-button {
    cursor: pointer;
    background: var(--ks-sys-color-neutral-surface2);
    border: 0 #d3d4d5;
    border-radius: 4px;
    text-align: center;
    margin: 0;
    -webkit-transition: .1s;
  }

  [dir] .vi-button:focus, [dir] .vi-button:hover {
    background-color: var(--ks-sys-color-neutral-surface2Hover);
    border-color: #009995;
  }

  .vi-button:active {
    outline: 0;
  }

  [dir] .vi-button:active {
    border-color: #009995;
    background-color: var(--ks-sys-color-neutral-surface2Active);
  }

  .vi-button--text {
    color: var(--ks-sys-color-primary-onSurface);
  }

  .vi-button--small {
    height: 30px;
    font-size: 12px;
  }

  [dir] .vi-button--small {
    padding: 9px 16px;
  }

  .vi-button--text {
    height: auto;
  }

  [dir] .vi-button--text {
    padding: 0;
    border-color: transparent;
  }

  [dir=ltr] .vi-button--text {
    background: 0 0;
  }

  .vi-button--text:focus, .vi-button--text:hover {
    color: var(--ks-sys-color-primary-onSurfaceHover);
  }

  [dir] .vi-button--text:focus, [dir] .vi-button--text:hover {
    border-color: transparent;
    background-color: transparent;
  }

  .vi-button--text:active {
    color: var(--ks-sys-color-primary-onSurfaceActive);
  }

  [dir] .vi-button--text:active {
    border-color: transparent;
    background-color: transparent;
  }

  /*! CSS Used from: https://lf16-ttmp.tiktokstaticb.com/obj/ttastatic-sg/tt4b_main/css/app.0690cee5.css */
  * {
    box-sizing: border-box;
  }

  /*! CSS Used from: https://ads.tiktok.com/i18n/common-style/v1.css */
  button {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: TikTok Text, TikTok Display, -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
  }

  /*! CSS Used from: Embedded */
  *, :after, :before {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-scroll-snap-strictness: proximity;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246/0.5);
    --tw-ring-offset-shadow: 0 0 transparent;
    --tw-ring-shadow: 0 0 transparent;
    --tw-shadow: 0 0 transparent;
    --tw-shadow-colored: 0 0 transparent;
  }

  /*! CSS Used from: Embedded */
  * {
    box-sizing: border-box;
  }

  /*! CSS Used from: Embedded */
  * {
    box-sizing: border-box;
  }

  .vi-schedule-calendar {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    position: relative;
    border: 1px solid #ececed;
    border-radius: 0 0 4px 4px;
  }

  .vi-schedule-calendar .table-wrap {
    margin: 0 auto;
    border-radius: 4px;
    overflow: hidden;
  }

  .vi-schedule-calendar-time-all {
    height: 39px;
    box-sizing: border-box;
  }

  .vi-schedule-calendar-week-td {
    width: 100px;
  }

  .vi-schedule-calendar-time-item {
    height: 31px;
  }

  .vi-schedule-calendar-selected {
    background: #009995;
  }

  .vi-schedule-calendar-table {
    width: 100%;
    border-radius: 4px;
    border-spacing: 0;
    table-layout: fixed;
    border-collapse: separate;
  }

  .vi-schedule-calendar-table tbody tr:last-child td {
    border-bottom: none;
  }

  .vi-schedule-calendar-table tr td, .vi-schedule-calendar-table tr th {
    outline: 0;
    color: #121415;
    text-align: center;
    min-width: 24px;
    line-height: 1.6em;
    white-space: nowrap;
    border-left: none;
    border-top: none;
    border-right: 1px solid #ececed;
    border-bottom: 1px solid #ececed;
    transition: background .2s ease;
  }

  .vi-schedule-calendar-table tr td:last-child, .vi-schedule-calendar-table tr th:last-child {
    border-right: none;
  }

  .vi-schedule-calendar .vi-schedule-result {
    color: #6d6e70;
    text-align: left;
    height: 22px;
    padding: 10px !important;
    line-height: 22px;
  }

  .vi-schedule-calendar .vi-schedule-result .clearfix {
    margin: 8px 0;
  }

  .vi-schedule-calendar .vi-schedule-result .clear-all {
    float: right;
    color: var(--ks-sys-color-primary-onSurface);
  }

  .vi-schedule-calendar .vi-schedule-result .clear-all:active, .vi-schedule-calendar .vi-schedule-result .clear-all:hover {
    color: var(--ks-sys-color-primary-onSurfaceHover);
  }

  .vi-schedule-calendar .vi-schedule-result-title {
    display: inline-block;
    min-width: 45px;
  }

  .vi-schedule-calendar .vi-schedule-result-value {
    color: #121415;
    white-space: normal;
  }

  .vi-popover__reference:focus:hover, .vi-popover__reference:focus:not(.focusing) {
    outline-width: 0;
  }

  .vi-button {
    -webkit-user-select: none;
    -moz-user-select: none;
  }

  .vi-button {
    display: inline-block;
  }

  .vi-button {
    font-size: 14px;
    height: 34px;
  }

  .vi-button {
    padding: 8px 16px;
  }

  .vi-button {
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: var(--ks-sys-color-neutral-surface2);
    border: 0 #d3d4d5;
    border-radius: 4px;
    color: #121415;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    transition: .1s;
    font-weight: 400;
    -ms-user-select: none;
  }

  .vi-button:focus, .vi-button:hover {
    background-color: var(--ks-sys-color-neutral-surface2Hover);
    border-color: #009995;
  }

  .vi-button:active {
    border-color: #009995;
    background-color: var(--ks-sys-color-neutral-surface2Active);
    outline: 0;
  }

  .vi-button--small {
    height: 30px;
    padding: 9px 16px;
    font-size: 12px;
  }

  .vi-button--text {
    height: auto;
    padding: 0;
    border-color: transparent;
    color: var(--ks-sys-color-primary-onSurface);
    background: 0 0;
  }

  .vi-button--text:focus, .vi-button--text:hover {
    color: var(--ks-sys-color-primary-onSurfaceHover);
    border-color: transparent;
    background-color: transparent;
  }

  .vi-button--text:active {
    color: var(--ks-sys-color-primary-onSurfaceActive);
    border-color: transparent;
    background-color: transparent;
  }

  /*! CSS Used from: Embedded */
  [class*=byted-] {
    box-sizing: border-box;
  }

  div, span, table, tbody, td, th, thead, tr {
    margin: 0;
    padding: 0;
    border: 0;
  }

  /*! CSS Used from: Embedded */
  [class*=byted-] {
    box-sizing: border-box;
  }

  div, span, table, tbody, td, th, thead, tr {
    margin: 0;
    padding: 0;
    border: 0;
  }

  /*! CSS Used from: Embedded */
  [dir] .vi-button {
    padding: 8px 16px;
  }

  .vi-button {
    display: inline-block;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }

  * {
    -webkit-box-sizing: border-box;
  }

  .vi-schedule-calendar {
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  [dir] .vi-schedule-calendar {
    border: 1px solid #ececed;
    border-radius: 0 0 4px 4px;
  }

  .vi-schedule-calendar .table-wrap {
    overflow: hidden;
  }

  [dir] .vi-schedule-calendar .table-wrap {
    border-radius: 4px;
    margin: 0 auto;
  }

  .vi-schedule-calendar-time-all {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    height: 39px;
  }

  .vi-schedule-calendar-week-td {
    width: 100px;
  }

  .vi-schedule-calendar-time-item {
    height: 31px;
  }

  [dir] .vi-schedule-calendar-selected {
    background: #009995;
  }

  .vi-schedule-calendar-table {
    border-collapse: separate;
    border-spacing: 0;
    table-layout: fixed;
    width: 100%;
  }

  [dir] .vi-schedule-calendar-table {
    border-radius: 4px;
  }

  [dir] .vi-schedule-calendar-table tbody tr:last-child td {
    border-bottom: none;
  }

  .vi-schedule-calendar-table tr td, .vi-schedule-calendar-table tr th {
    color: #121415;
    line-height: 1.6em;
    min-width: 24px;
    outline: 0;
    white-space: nowrap;
  }

  [dir] .vi-schedule-calendar-table tr td, [dir] .vi-schedule-calendar-table tr th {
    border-bottom: 1px solid #ececed;
    border-top: none;
    text-align: center;
    -webkit-transition: background .2s ease;
    transition: background .2s ease;
  }

  [dir=ltr] .vi-schedule-calendar-table tr td, [dir=ltr] .vi-schedule-calendar-table tr th {
    border-left: none;
    border-right: 1px solid #ececed;
  }

  [dir=ltr] .vi-schedule-calendar-table tr td:last-child, [dir=ltr] .vi-schedule-calendar-table tr th:last-child {
    border-right: none;
  }

  .vi-schedule-calendar .vi-schedule-result {
    color: #6d6e70;
    height: 22px;
    line-height: 22px;
  }

  [dir] .vi-schedule-calendar .vi-schedule-result {
    padding: 10px !important;
  }

  [dir=ltr] .vi-schedule-calendar .vi-schedule-result {
    text-align: left;
  }

  [dir] .vi-schedule-calendar .vi-schedule-result .clearfix {
    margin: 8px 0;
  }

  .vi-schedule-calendar .vi-schedule-result .clear-all {
    color: var(--ks-color-primary-onSurface);
  }

  [dir=ltr] .vi-schedule-calendar .vi-schedule-result .clear-all {
    float: right;
  }

  .vi-schedule-calendar .vi-schedule-result .clear-all:active, .vi-schedule-calendar .vi-schedule-result .clear-all:hover {
    color: var(--ks-color-primary-onSurfaceHover);
  }

  .vi-schedule-calendar .vi-schedule-result-title {
    display: inline-block;
    min-width: 45px;
  }

  .vi-schedule-calendar .vi-schedule-result-value {
    color: #121415;
    white-space: normal;
  }

  .vi-popover__reference:focus:hover, .vi-popover__reference:focus:not(.focusing) {
    outline-width: 0;
  }

  .vi-button {
    -webkit-user-select: none;
  }

  .vi-button {
    -ms-user-select: none;
    -moz-user-select: none;
  }

  .vi-button {
    display: inline-block;
  }

  .vi-button {
    font-size: 14px;
    height: 34px;
  }

  [dir] .vi-button {
    padding: 8px 16px;
  }

  .vi-button {
    -webkit-appearance: none;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #121415;
    font-weight: 400;
    line-height: 1;
    outline: 0;
    white-space: nowrap;
  }

  [dir] .vi-button {
    background: var(--ks-color-neutral-surface2);
    border: 0 #d3d4d5;
    border-radius: 4px;
    cursor: pointer;
    margin: 0;
    text-align: center;
    -webkit-transition: .1s;
    transition: .1s;
  }

  [dir] .vi-button:focus, [dir] .vi-button:hover {
    background-color: var(--ks-color-neutral-surface2Hover);
    border-color: #009995;
  }

  .vi-button:active {
    outline: 0;
  }

  [dir] .vi-button:active {
    background-color: var(--ks-color-neutral-surface2Active);
    border-color: #009995;
  }

  .vi-button--small {
    font-size: 12px;
    height: 30px;
  }

  [dir] .vi-button--small {
    padding: 9px 16px;
  }

  .vi-button--text {
    color: var(--ks-color-primary-onSurface);
    height: auto;
  }

  [dir] .vi-button--text {
    border-color: transparent;
    padding: 0;
  }

  [dir=ltr] .vi-button--text {
    background: 0 0;
  }

  .vi-button--text:focus, .vi-button--text:hover {
    color: var(--ks-color-primary-onSurfaceHover);
  }

  [dir] .vi-button--text:focus, [dir] .vi-button--text:hover {
    background-color: transparent;
    border-color: transparent;
  }

  .vi-button--text:active {
    color: var(--ks-color-primary-onSurfaceActive);
  }

  [dir] .vi-button--text:active {
    background-color: transparent;
    border-color: transparent;
  }

  * {
    box-sizing: border-box;
  }

  /*! CSS Used from: Embedded */
  #creation-app .vi-button > * {
    vertical-align: middle;
  }

  button {
    font-family: var(--ttam-font-family-default);
  }

  * {
    box-sizing: border-box;
  }

  /*! CSS Used from: Embedded */
  button {
    color: inherit;
    font: inherit;
    margin: 0;
  }

  button {
    overflow: visible;
  }

  button {
    text-transform: none;
  }

  button {
    -webkit-appearance: button;
    cursor: pointer;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  td, th {
    padding: 0;
  }

  *, :after, :before {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .clearfix {
    zoom: 1;
  }

  .clearfix::after, .clearfix::before {
    content: '';
    display: table;
  }

  .clearfix::after {
    clear: both;
  }

  /*! CSS Used from: Embedded */
  button {
    color: inherit;
    font: inherit;
    margin: 0;
  }

  button {
    overflow: visible;
  }

  button {
    text-transform: none;
  }

  button {
    -webkit-appearance: button;
    cursor: pointer;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  td, th {
    padding: 0;
  }

  * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  *:before, *:after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .clearfix {
    zoom: 1;
  }

  .clearfix::before, .clearfix::after {
    content: '';
    display: table;
  }

  .clearfix::after {
    clear: both;
  }

  ///*! CSS Used fontfaces */
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Text;
  //  font-weight: 300;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Light.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Light.woff) format("woff");
  //}
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Text;
  //  font-weight: 400;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Regular.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Regular.woff) format("woff");
  //}
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Text;
  //  font-weight: 500;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Medium.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Medium.woff) format("woff");
  //}
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Text;
  //  font-weight: 700;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Bold.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Bold.woff) format("woff");
  //}
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Text;
  //  font-weight: 900;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Black.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Black.woff) format("woff");
  //}
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Text;
  //  font-weight: 300;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Light.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Light.woff) format("woff");
  //}
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Text;
  //  font-weight: 400;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Regular.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Regular.woff) format("woff");
  //}
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Text;
  //  font-weight: 500;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Medium.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Medium.woff) format("woff");
  //}
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Text;
  //  font-weight: 700;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Bold.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Bold.woff) format("woff");
  //}
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Text;
  //  font-weight: 900;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Black.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Text/TikTok-Text-Black.woff) format("woff");
  //}
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Display;
  //  font-weight: 300;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Light.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Light.woff) format("woff");
  //}
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Display;
  //  font-weight: 400;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Regular.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Regular.woff) format("woff");
  //}
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Display;
  //  font-weight: 500;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Medium.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Medium.woff) format("woff");
  //}
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Display;
  //  font-weight: 700;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Bold.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Bold.woff) format("woff");
  //}
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Display;
  //  font-weight: 900;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Black.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Black.woff) format("woff");
  //}
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Display;
  //  font-weight: 300;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Light.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Light.woff) format("woff");
  //}
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Display;
  //  font-weight: 400;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Regular.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Regular.woff) format("woff");
  //}
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Display;
  //  font-weight: 500;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Medium.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Medium.woff) format("woff");
  //}
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Display;
  //  font-weight: 700;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Bold.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Bold.woff) format("woff");
  //}
  //@font-face {
  //  font-display: swap;
  //  font-family: TikTok Display;
  //  font-weight: 900;
  //  src: url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Black.woff2) format("woff2"), url(https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/assets/fonts-tiktok/Display/TikTok-Display-Black.woff) format("woff");
  //}
}
</style>



// WEBPACK FOOTER //
// src/pages/pas/component/component_custom_datetime_picker.vue